export default __webpack_public_path__ + "static/media/fontRoboto400_vietnamese.3230f9b0.woff2";